import {
  filterSubsectionsByName,
  mapBulletPointsWithIcon,
} from 'components/PageSections/utils';

import { BulletPointWithIconProps } from '../BulletPointWithIcon';
import { ProductDescriptionProps } from './ProductDescription';

export function parseProductDescription(
  section: Queries.ContentfulSection001 | undefined | null,
): ProductDescriptionProps {
  const { metadata } = section || {};

  // Ensure flags is not undefined, and filter out any null/undefined elements
  const safeFlags: Queries.ContentfulFlag001[] =
    metadata?.flags?.filter(
      (flag): flag is Queries.ContentfulFlag001 =>
        flag !== null && flag !== undefined,
    ) || [];

  const [dollarAmount, centsAmount] =
    metadata?.context?.price?.value?.split('.') || [];

  const subsections = section?.subsections as Queries.ContentfulSection001[];

  const topBulletPointsWithIconSubsection = filterSubsectionsByName(
    'BulletPointWithIcon',
    subsections,
  );
  const bottomBulletPointsWithIconSubsection = filterSubsectionsByName(
    'BulletPointWithIconInline',
    subsections,
  );

  const topBulletPoints: BulletPointWithIconProps[] = mapBulletPointsWithIcon(
    topBulletPointsWithIconSubsection,
  );
  const bottomBulletPoints: BulletPointWithIconProps[] =
    mapBulletPointsWithIcon(bottomBulletPointsWithIconSubsection);

  return {
    flags: safeFlags,
    title: metadata?.title,
    price: {
      dollarAmount: dollarAmount,
      centsAmount: centsAmount,
    },
    frequency: metadata?.context?.price?.frequency || null,
    topBulletPoints: topBulletPoints || null,
    bottomBulletPoints: bottomBulletPoints || null,
    cta: metadata?.ctas?.[0] || null,
  };
}
